export default __webpack_public_path__ + "static/media/arrow-down.2db52c18.svg";